require('./model.js');

Pegasus.Template = Pegasus.Model.extend({

});

Pegasus.Template.FIXTURES = [];
